import React from 'react';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';

import { IContentfulImage } from '../../../interfaces/contentful-image.interface';
import { ILibraryMeetingPlaceDictionary } from '../../../queries/fragments/libraryMeetingPlaceDictionary';
import { ILibraryOpeningHours } from '../../../queries/fragments/libraryOpeningHours';
import { ILibraryOpeningHoursException } from '../../../queries/fragments/libraryOpeningHoursException';
import { TextArrayProps } from '../../page-components/editorial-page-full-width/editorial-page-full-width';
import IkeaProductCardInHomePage from '../../page-components/home-page/ikea-product-card';
import * as blockSections from '../block-sections';
import CountdownCard from '../countdown-block/countdown-card';
import { FallbackBlock } from '../fallback-block';

interface RenderBlocksProps {
  blocks: blockSections.BlockSections[];
  meetingPlaceName?: string;
  integrationId?: string;
  businessUnitCode?: string;
  header?: string;
  logo?: IContentfulImage;
  node_locale?: string;
  primaryLanguage?: string;
  topBlock?: boolean;
  textItem?: TextArrayProps[];
  masonry?: boolean;
  dictionary?: ILibraryMeetingPlaceDictionary;
  showIkeaProductCard?: boolean;
  meetingPlaceOpeningHours?: {
    openingHours?: ILibraryOpeningHours;
    openingHoursExceptions?: ILibraryOpeningHoursException[];
    timezone?: string;
  };
  tenantOpeningHoursDetails?: {
    name: string;
    openingHours: ILibraryOpeningHours;
    openingHoursExceptions: ILibraryOpeningHoursException[];
    timezone: string;
    slug: string;
  }[];
  htmlTitleSuffix?: string;
}
export const RenderBlocks = ({
  blocks,
  logo,
  meetingPlaceName,
  integrationId,
  businessUnitCode,
  header,
  node_locale,
  primaryLanguage,
  topBlock,
  textItem,
  masonry = false,
  dictionary,
  showIkeaProductCard = false,
  meetingPlaceOpeningHours,
  tenantOpeningHoursDetails,
  htmlTitleSuffix,
}: RenderBlocksProps) => {
  if (masonry) {
    return (
      <ResponsiveMasonry columnsCountBreakPoints={{ 0: 1, 640: 2 }}>
        <Masonry columnsCount={2} style={{ gap: '1.25rem' }}>
          {showIkeaProductCard && (
            <IkeaProductCardInHomePage
              node_locale={node_locale || ''}
              primaryLanguage={primaryLanguage || ''}
              businessUnitCode={businessUnitCode || ''}
              buyNowText={dictionary?.buyAtIkea || ''}
              variant="homepage"
              pageName={
                htmlTitleSuffix
                  ? meetingPlaceName + htmlTitleSuffix
                  : meetingPlaceName
                    ? meetingPlaceName
                    : ''
              }
            />
          )}
          {process.env.GATSBY_SHOW_COUNTDOWN_TIMER === 'true' && (
            <CountdownCard
              imgClassName={
                'bg-smallDynamicStrokeCountdownTimer h-[330px] justify-center'
              }
              showNavigationButton={true}
              titleClassName={'mb-[40px] text-headingl lg:text-headingm'}
            />
          )}

          {blocks?.map((block, index) => {
            const newBlockProps = {
              ...block,
              logo,
              meetingPlaceName,
              integrationId,
              header,
              index,
              node_locale,
            };
            const Component = blockSections[block.blocktype] || FallbackBlock;
            return (
              <Component
                key={`${index}-${block.id}`}
                topBlock={topBlock ? topBlock : null}
                textItem={textItem ? textItem : null}
                {...(newBlockProps as any)}
              />
            );
          })}
        </Masonry>
      </ResponsiveMasonry>
    );
  } else {
    return (
      <>
        {blocks?.map((block, index) => {
          const newBlockProps = {
            ...block,
            logo,
            meetingPlaceName,
            integrationId,
            header,
            index,
            node_locale,
            meetingPlaceOpeningHours,
            tenantOpeningHoursDetails,
          };
          const Component = blockSections[block.blocktype] || FallbackBlock;
          return (
            <Component
              key={`${index}-${block.id}`}
              topBlock={topBlock ? topBlock : null}
              textItem={textItem ? textItem : null}
              {...(newBlockProps as any)}
            />
          );
        })}
      </>
    );
  }
};
